import { useEffect, useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {
  Users,
  BarChart3,
  TrendingUp,
  Target,
  Calendar,
  Plus,
  DollarSign,
} from 'lucide-react'

const TeamsSection = () => {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    // Animate dashboard elements
    gsap.from('.dashboard-card', {
      y: 50,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: sectionRef.current,
        start: 'top 80%',
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
      },
    })

    // Animate metrics
    gsap.from('.metric-item', {
      scale: 0,
      opacity: 0,
      duration: 0.6,
      stagger: 0.1,
      ease: 'back.out(1.7)',
      scrollTrigger: {
        trigger: sectionRef.current,
        start: 'top 80%',
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
      },
    })
  }, [])

  const teamMembers = [
    {
      name: '',
      role: '',
      avatar: '',
      status: '',
      leads: '',
    },
    {
      name: ' ',
      role: ' Lead',
      avatar: '',
      status: '',
      leads: '',
    },
    {
      name: ' ',
      role: ' ',
      avatar: '',
      status: '',
      leads: '',
    },
    {
      name: ' ',
      role: ' ',
      avatar: '',
      status: '',
      leads: '',
    },
  ]

  const metrics = [
    {
      icon: Users,
      label: 'Team Members',
      value: '10',
      change: '+2',
      color: 'text-blue-600',
    },
    {
      icon: Target,
      label: 'Total Leads',
      value: '10', 
      change: '+15%',
      color: 'text-green-600',
    },
    {
      icon: TrendingUp,
      label: 'Conversion Rate',
      value: '10',
      change: '+2.1%',
      color: 'text-purple-600',
    },
    {
      icon: DollarSign,
      label: 'Revenue',
      value: 'Counting',
      change: '+8.3%',
      color: 'text-orange-600',
    },
  ]


}

export default TeamsSection